const Info = ({ data }) => {
  const styles = {
    background: `
      linear-gradient(90deg, #ffffff 0%, #fafafa 100%)
    `,
    boxSizing: "border-box",
  };

  return (
    <div
      className="relative mx-auto mb-[50px] sm:mb-0 top-[20px] sm:top-[-82px] w-full max-w-[1072px] text-center px-6 py-4 md:px-14 md:py-6 flex flex-col md:flex-row items-center justify-around rounded-lg shadow-md"
      style={styles}
    >
      <div className="mb-6 md:mb-0 text-center md:text-left">
        <h2 className="text-xl md:text-3xl font-semibold text-black">Duration</h2>
        <p className="mt-3 md:mt-5 text-[#444] text-sm">{data.duration}</p>
      </div>
      <div className="mb-6 md:mb-0 text-center md:text-left">
        <h2 className="text-xl md:text-3xl font-semibold text-black">Schedule</h2>
        <p className="mt-3 md:mt-5 text-[#444] text-sm">{data.schedule}</p>
      </div>
      <div className="text-center md:text-left">
        <h2 className="text-xl md:text-3xl font-semibold text-black">Eligibility</h2>
        <p className="mt-3 md:mt-5 text-[#444] text-sm">{data.eligibility}</p>
      </div>
    </div>
  );
};

export default Info;
